var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn",class:_vm.btnClass,attrs:{"evaluation-tool-trigger":""},on:{"click":_vm.loadEvaluationTool}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }